<template>
  <div class="session">
    <Progression v-if="loading"></Progression>
    <div v-else-if="canEdit()" class="session-management">
      <v-container fill-height fluid>
        <v-layout align-center justify-center>
          <v-flex sm12 md6>
            <div class="session-tabs">
              <v-btn
                v-for="tab in tabs"
                :key="tab.id"
                :ref="tab.ref"
                :class="['tab-btn', { active: selected === tab }]"
                @click="selected = tab"
              >
                {{ tab.name }}
              </v-btn>
              <component
                :is="selected.component"
                v-bind="selected.props"
                class="tab"
              ></component>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-container v-else fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex sm12 md6>
          <SessionDetails :passed-session="session"></SessionDetails>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Progression from "@/components/Progression";
import SessionDetails from "./SessionDetails";
import EventsManagement from "../Event/EventsManagement";
import adaptersIn from "@/services/data-adapter/incoming/scheduler";

export default {
  components: {
    Progression,
    SessionDetails
  },

  props: {
    preload: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    activeTab: 1,
    selected: "",
    loading: true,
    session: null
  }),

  computed: {
    tabs: function() {
      return [
        {
          id: 1,
          name: this.$t("app.buttons.tabs.details"),
          ref: "detailsButton",
          component: SessionDetails,
          props: {
            passedSession: this.session
          }
        },
        {
          id: 2,
          name:
            this.$t("scheduler.event.name-plural") +
            " (" +
            this.session.size +
            ")",
          ref: "eventsButton",
          component: EventsManagement,
          props: {
            editable: !this.session.cancelled,
            events: this.session.events
          }
        }
      ];
    }
  },

  watch: {
    loading: function(val) {
      if (!val && this.canEdit()) {
        this.$nextTick(function() {
          this.$refs.detailsButton[0].$emit("click");
        });
      }
    }
  },

  mounted: function() {
    this.$nextTick(function() {
      if (this.preload) {
        this.session = this.preload;
        this.adaptEvents();
      } else {
        this.getSession();
      }
    });
  },

  methods: {
    canEdit() {
      const role = this.$store.getters["site/user"].role;
      return role === "admin" || role === "teacher";
    },

    back() {
      this.$router.go(-1);
    },

    getSession() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$http
          .get("/eventsgroups/" + this.$route.params.sessionId + "?trashed=1")
          .then(response => {
            adaptersIn.session(response.data.events_groups).then(res => {
              this.session = res;
              this.loading = false;
              resolve(true);
            });
          })
          .catch(error => {
            if (process.env.NODE_ENV !== "production") {
              console.log(error);
            }
            return reject(false);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-btn {
  width: 50%;
  padding: 6px 10px;
  background: #fff;
  cursor: pointer;
  margin-left: 0px;
  margin-right: 0px;
  border: 2px solid #ccc;
  outline: none;
}
.active {
  border-bottom: 3px solid #ed1c24;
  background: #fcfcfc;
}
.tab {
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
